<div
  [ngClass]="{ 'label-inline': specs().isLabelInline }"
  class="form-item-component form-item-component-{{ theme() | lowercase }} form-item-component--{{ specs().type }}">
  @if (specs().label && specs().type !== "BOOLEAN") {
    <div [innerHTML]="specs().label" class="label label-{{ theme() | lowercase }}"></div>
  }
  <div [ngStyle]="customStyle()" class="input">
    @switch (specs().type) {
      @case ("TEXT") {
        <input
          (ngModelChange)="valueChange($event)"
          [attr.maxlength]="specs().rules?.max"
          [attr.minlength]="specs().rules?.min"
          [autocomplete]="specs().autocomplete ? specs().autocomplete : ''"
          [class.input-error]="isError && tips"
          [disabled]="specs().disabled || false"
          [id]="specs().key"
          [name]="specs().key"
          [ngModel]="val"
          [placeholder]="specs().placeholder ?? ''"
          [readonly]="specs().readonly"
          class="input-text input-{{ theme() | lowercase }}"
          type="text" />
      }
      @case ("TEXTAREA") {
        <textarea
          (ngModelChange)="valueChange($event)"
          [attr.maxlength]="specs().rules?.max"
          [class.input-error]="isError && tips"
          [disabled]="specs().disabled || false"
          [id]="specs().key"
          [name]="specs().key"
          [ngModel]="val"
          [placeholder]="specs().placeholder ?? ''"
          [readonly]="specs().readonly"
          class="input-textarea input-{{ theme() | lowercase }}"
          rows="2"></textarea>
      }
      @case ("NUMERIC") {
        <input
          (ngModelChange)="valueChange($event)"
          [attr.max]="specs().rules?.max"
          [attr.min]="specs().rules?.min"
          [class.input-error]="isError && tips"
          [disabled]="specs().disabled || false"
          [id]="specs().key"
          [name]="specs().key"
          [ngModel]="val"
          [readonly]="specs().readonly"
          class="input-number input-{{ theme() | lowercase }}"
          type="number" />
      }
      @case ("DATE") {
        <input
          (ngModelChange)="valueChange($event)"
          [attr.max]="specs().rules?.max"
          [attr.min]="specs().rules?.min"
          [class.input-error]="isError && tips"
          [disabled]="specs().disabled || false"
          [id]="specs().key"
          [name]="specs().key"
          [ngModel]="val"
          [readonly]="specs().readonly"
          class="input-date input-{{ theme() | lowercase }}"
          type="date" />
      }
      @case ("LIST") {
        <select
          (ngModelChange)="valueChange($event)"
          [class.input-error]="isError && tips"
          [disabled]="specs().disabled || false"
          [id]="specs().key"
          [name]="specs().key"
          [ngModel]="val"
          class="input-select input-{{ theme() | lowercase }}">
          @if (specs().placeholder) {
            <option disabled hidden>{{ specs().placeholder }}</option>
          }
          @for (opt of specs().list; track opt) {
            <option [value]="opt.key">
              {{ opt.label }}
            </option>
          }
        </select>
      }
      @case ("SEARCH") {
        <input
          (click)="onSearchSelectClick()"
          (ngModelChange)="valueChange($event)"
          [class.input-dropdown--open]="dropdown.isOpen"
          [class.input-error]="isError && tips"
          [id]="specs().key"
          [name]="specs().key"
          [ngModel]="val"
          [placeholder]="specs().placeholder ?? ''"
          [readonly]="true"
          class="input-dropdown input-search input-{{ theme() | lowercase }}"
          type="text" />
        <app-dropdown
          (selected)="onSearchDropdownSelected($event)"
          [class.dropdown--open]="dropdown.isOpen"
          [isBig]="!isMobile()"
          [isOpen]="dropdown.isOpen"
          [items]="dropdown.list"
          class="dropdown"></app-dropdown>
      }
      @case ("BOOLEAN") {
        <label class="input-checkbox-container input-checkbox-container-{{ theme() | lowercase }}">
          <div
            [innerHTML]="specs().label"
            class="input-checkbox-label input-checkbox-label-{{ theme() | lowercase }}"></div>
          <input
            (ngModelChange)="valueChange($event)"
            [class.input-error]="isError && tips"
            [disabled]="specs().disabled || false"
            [id]="specs().key"
            [name]="specs().key"
            [ngModel]="val"
            class="input-checkbox"
            type="checkbox" />
          <div class="input-checkbox-custom input-checkbox-custom-{{ theme() | lowercase }}"></div>
        </label>
      }
    }
    <div>
      @if (isError && tips) {
        <div class="error error-{{ theme() | lowercase }}">{{ tips }}</div>
      }
    </div>
  </div>
</div>
